<template>
  <div class="text-center">
    <div :class="[$style.container__modal]">
      <div :class="$style.container__modal__innerPadding">
        <img :class="[$style.container__modal__icon__1]" src="@/assets/img/trail/trail-icon.png">

        <h3 :class="[$style.heading__1, $style.mb__24]">
          Juntos trilharemos seu caminho profissional!
        </h3>

        <p :class="[$style.paragraph__1, $style.mb__16]">
          Indicaremos alguns caminhos profissionais onde cada um possui um conjunto de habilidades e grandes oportunidades de mercado. Escolha o que mais combina com suas características e objetivos!
        </p>

        <p :class="[$style.paragraph__1, $style.mb__16]">
          Após a escolha da trilha, recomendaremos os cursos e materiais relacionados para você alcançar seus objetivos e ferramentas para acompanhamento do progresso.
        </p>

        <h5 :class="[$style.highlight__1, $style.mb__24]">
          Pronto para o sucesso?
        </h5>

        <div :class="$style.button__1">
          <PrimaryButton @click="picked">
            Escolher trilha
          </PrimaryButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '../buttons/PrimaryButton.vue'
export default {
	components: { PrimaryButton },
  name: 'TrailWelcome',
  emits: ['go'],
  setup (props, { emit }) {
    const picked = () => {
      emit('go')
    }

    return { picked }
  }
}
</script>

<style module lang="scss">
  @import "~@/components/trail/trail.scss";
</style>